module.exports = __webpack_public_path__ + "static/img/preview-02.685ae8c7.webp";